import type { FormTourConfig } from './formTour';

const ACCOUNT_SETTINGS_START_PATH = '/settings/account';
const SETTINGS_PATH_PREFIX = '/settings';

export const accountSettingsTour = {
  taskId: 'account_settings',
  storageKey: 'onboarding-account-settings-tour-step',
  startPath: ACCOUNT_SETTINGS_START_PATH,
  activePathPrefix: SETTINGS_PATH_PREFIX,
  navStepCount: 1,
  overlineLabel: 'Add Agency Info Tour',
  steps: [
    {
      title: 'Open Settings',
      description:
        'Click Settings in the sidebar, then open My Account under Profile to edit your agency information.',
      targetTestIds: ['@sidebar-settings'],
    },
    {
      title: 'Enter your agency name',
      description: 'Add your recruiting agency name. Changes save automatically as you edit.',
      targetTestIds: ['@account-settings-name'],
      disableBack: true,
    },
    {
      title: 'Upload your agency logo',
      description: 'Optional: upload a logo to brand your Harbor workspace.',
      targetTestIds: ['@account-settings-logo-upload'],
    },
    {
      title: 'Review your agency section',
      description:
        'Confirm your agency name and logo look correct. When you are ready, mark this step complete.',
      targetTestIds: ['@account-settings-agency'],
    },
  ],
  stepActions: {
    0: {
      type: 'wait-for-target',
      advanceTo: 1,
      waitForTargetTestIds: ['@account-settings-name'],
    },
    1: { type: 'next' },
    2: { type: 'next' },
    3: { type: 'complete' },
  },
} as const satisfies FormTourConfig;
